module.exports = __webpack_public_path__ + "static/media/forward.f42e780f.svg";